import { rankItems } from '@/mocks/gossipData';
import { StatusBadge, TrendIcon } from './common';

export default function RankSection() {
  return (
    <section id="rank" className="w-full scroll-mt-24 bg-accent-50">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="h-1.5 w-1.5 rounded-full bg-accent-600" />
              <span className="text-xs font-bold tracking-widest text-accent-700 uppercase">反转热度榜</span>
            </div>
            <h2 className="mt-1 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">本周最烫的 6 个瓜</h2>
            <p className="mt-1.5 text-sm text-foreground-600 md:text-[15px]">按讨论热度排序，箭头表示较前一日走向，点进标题看完整反转轨迹。</p>

            <div className="mt-6 flex flex-col gap-2.5">
              {rankItems.map((it, idx) => (
                <a
                  key={it.title}
                  href="#feed"
                  className="group flex cursor-pointer items-center gap-3 rounded-xl border border-accent-200/70 bg-background-50 px-3 py-3 transition-colors hover:border-accent-300 hover:bg-background-50 md:px-4"
                >
                  <span
                    className={`font-heading text-2xl font-black ${
                      idx === 0 ? 'text-primary-600' : idx === 1 ? 'text-accent-600' : 'text-background-400'
                    }`}
                  >
                    {String(idx + 1).padStart(2, '0')}
                  </span>
                  <TrendIcon trend={it.trend} />
                  <div className="min-w-0 flex-1">
                    <h3 className="truncate text-sm font-bold text-foreground-900 transition-colors group-hover:text-accent-800 md:text-base">
                      {it.title}
                    </h3>
                    <div className="mt-1 flex items-center gap-2">
                      <StatusBadge label={it.kind} className="!px-1.5 !text-[10px]" />
                      <span className="text-xs text-foreground-500">{it.kind === '待核实' ? '热度回落待核' : it.kind === '辟谣' ? '辟谣后热度下行' : '讨论热度持续'}</span>
                    </div>
                  </div>
                  <div className="flex shrink-0 items-center gap-1.5 text-foreground-500">
                    <i className="ri-fire-fill text-accent-500" />
                    <span className="font-heading text-sm font-bold text-foreground-800 md:text-base">{it.heat}</span>
                  </div>
                </a>
              ))}
            </div>
          </div>

          <aside className="flex flex-col gap-4">
            <div className="rounded-2xl border border-accent-200/70 bg-background-50 p-5 md:p-6">
              <div className="flex items-center gap-2 text-xs font-bold tracking-widest text-accent-700 uppercase">
                <i className="ri-line-chart-line" /> 本周风向速览
              </div>
              <ul className="mt-4 space-y-3.5 text-sm">
                {[
                  ['反转类话题占比', '41%', '较上周 +6%'],
                  ['澄清后热度回落', '67%', '辟谣见效比提升'],
                  ['实锤类留存讨论', '52%', '有据内容更被信任'],
                ].map(([k, v, n]) => (
                  <li key={k} className="flex items-center justify-between gap-2">
                    <span className="text-foreground-600">{k}</span>
                    <span className="inline-flex items-center gap-1.5">
                      <span className="font-heading text-lg font-black text-foreground-950">{v}</span>
                      <span className="text-[11px] text-accent-700">{n}</span>
                    </span>
                  </li>
                ))}
              </ul>
              <div className="mt-4 rounded-xl bg-accent-100/70 p-3 text-[13px] leading-relaxed text-accent-900">
                本周上榜话题中，超过六成经当事人或平台回应后热度明显回落，理性吃瓜正成为主流选择。
              </div>
            </div>

            <a
              href="#timeline"
              className="group flex cursor-pointer flex-1 items-center justify-between rounded-2xl bg-primary-500 p-5 text-background-50 transition-colors hover:bg-primary-600 md:p-6"
            >
              <div>
                <div className="text-xs font-semibold text-primary-200">不想错过反转？</div>
                <div className="mt-1 font-heading text-lg font-bold leading-snug">订阅单个事件的后续进展</div>
              </div>
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-background-50/20 transition-transform group-hover:translate-x-1">
                <i className="ri-arrow-right-line text-xl" />
              </span>
            </a>
          </aside>
        </div>
      </div>
    </section>
  );
}